var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gd-button',{staticClass:"my-2",attrs:{"variant":"outline","size":"md"},on:{"click":_vm.editDomains}},[_vm._v(" "+_vm._s(_vm.$t('groovesell_vendor_settings_goto_domains'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }